import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import endpoints from "src/app/helpers/endpoints";
import { CustomerDashboardService } from "src/app/pages/customer-dashboard/services/customer-dashboard.service";
import { ApiService } from "src/app/services/api.service";

@Component({
  selector: "fury-agreements-tabs",
  templateUrl: "./agreements-tabs.component.html",
  styleUrls: ["./agreements-tabs.component.scss"],
})
export class AgreementsTabsComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = [
    "agent",
    "serviceAgreementNumber",
    "agreementStatus",
    "user",
    "planType",
    "propertyType",
    "propertySize",
    "coverageTerm",
    "paymentMethod",
    "agreementPrice",
    "netReceived",
    "balance",
    "createdOn",
    "waitingPeriod",
    "agreementEffectiveDate",
    "copaymentFee",
    "streetAddress",
    "city",
    "state",
    "zip",
    "mobileNumber",
    "emailAddress",
    "hardCopy",
    "mailingTracking",
    "cancellationDate",
    "reasonForCancellation",
    "payments",
    "surcharge",
    "leadSource",
    "actions",
  ];
  dataSource = [];
  selectedTabIndex = 0;
  pageIndex = 0;
  pageSize = 5;
  totalCount = 0;
  searchType = "contains";
  @Input() userId = "";
  @Input() editorAccess:boolean;
  selectConfig = { disableOptionCentering: true, panelClass: "custom-class" };
  tabMapping = {
    0: "",
    1: "Active",
    2: "Inactive",
    3: "Pending",
    4: "Cancelled",
  };
  ngUnsubscribe = new Subject<void>();
  constructor(private apiService: ApiService, private customerDashboardService: CustomerDashboardService) {}

  ngOnInit(): void {
    this.fetchAgreementsDetails();
    this.fetchAgreementData();
  }
  fetchAgreementsDetails() {
    const status =
      this.selectedTabIndex === 0 // 0 means all
        ? ""
        : `&tabName=${this.tabMapping[this.selectedTabIndex]}`;
    this.apiService
      .get(
        `${endpoints.customerDashboard.getCustomerAgreements(
          this.userId
        )}?page=${this.pageIndex + 1}&searchType=${this.searchType}&size=${
          this.pageSize
        }${status}`
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res: any) => {
          this.dataSource = res.body.agreements.data;
          this.totalCount = res.body?.agreements?.total;
        },
        () => {
          this.dataSource = [];
          this.totalCount = 0;
        }
      );
  }

  fetchAgreementData() {
    this.customerDashboardService.shouldViewFetchAgreement$
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe(res =>{
      if(res){
        this.fetchAgreementsDetails();
      }
    })
  }

  onTabChange(event: any) {
    this.selectedTabIndex = event.index;
    this.pageIndex = 0;
    this.totalCount = 0;
    this.fetchAgreementsDetails();
  }

  pageSizeChange(event: any) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.fetchAgreementsDetails();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
